module.exports = __webpack_public_path__ + "img/rule_title.6d227813.jpg";